import { CLOUDINARY_URL } from "./constants";

export const buildImageUrl = (imageLink?: string | null): string => {
  if (!imageLink) return "/placeholder.svg";
  if (imageLink.startsWith("http")) return imageLink;
  return `${CLOUDINARY_URL}${imageLink}`;
};
